<template>
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0016 1.5941C10.1814 1.41419 10.473 1.41419 10.6529 1.5941L12.6999 3.64112L12.7411 3.6883C12.8785 3.86881 12.8648 4.12759 12.6999 4.2924L10.6529 6.33942L10.6057 6.3807C10.4252 6.51804 10.1664 6.50434 10.0016 6.33942L9.96029 6.29224C9.82295 6.11173 9.83665 5.85295 10.0016 5.68814L11.2617 4.42705L4.95377 4.42735C3.37104 4.42735 2.08794 5.71045 2.08794 7.29318C2.08794 8.83824 3.31065 10.0979 4.84119 10.1567L4.95373 10.1589H7.00075C7.25513 10.1589 7.46133 10.3651 7.46133 10.6195C7.46133 10.8543 7.28561 11.0481 7.05853 11.0765L7.00076 11.0801H4.95374C2.86224 11.0801 1.16675 9.38456 1.16675 7.29306C1.16675 5.24343 2.79508 3.57414 4.82861 3.50812L4.95365 3.50612L11.2605 3.50553L10.0013 2.24533L9.96004 2.19815C9.82271 2.01764 9.8364 1.75886 10.0013 1.59405L10.0016 1.5941Z"
      :fill="fillColor"
      :stroke="strokeColor"
    />
  </svg>
</template>
s

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fillColor: {
      type: String,
      required: false,
      default: '#111827',
    },
    strokeColor: {
      type: String,
      required: false,
      default: '111827',
    },
  },
  setup({}, { emit }) {},
})
</script>

<style scoped></style>
